export async function generateOneTrustJwtToken(userId: string): Promise<string> {
  try {
    if (!userId) {
      throw new Error('User ID is required to generate OneTrust JWT token');
    }

    const response = await fetch('/api/generateToken', {
      body: JSON.stringify({ userId }),
      headers: {
        'Content-Type': 'application/json',
      },
      method: 'POST',
    });

    if (!response.ok) {
      const errorText = await response.text();
      throw new Error(`Token verification failed: ${errorText}`);
    }

    const result = await response.json();

    if (result.error) {
      throw new Error(`Token verification error: ${result.error}`);
    }

    return result.encoded;
  } catch (_e) {
    // logApiError(e as Error, 'generateOneTrustJwtToken');
    return '';
  }
}
